import { css } from "@emotion/react";
import colors from "assets/css/colors";
import { lineClamp1Css } from "assets/css/lineClamp.css";

export const rootCss = css`
  margin: 25px 0;
  font-size: 14px;
`;

export const listCss = css`
  display: flex;
  margin: 0;
  padding: 0;
  list-style: none;
`;

export const linkCss = [
  lineClamp1Css,
  css`
    display: -webkit-inline-box;
    color: ${colors.grey};
    text-decoration: none;

    &:focus-within,
    &:hover {
      color: ${colors.mainBlue};
    }
  `,
];

export const activeCss = [
  lineClamp1Css,
  css`
    display: -webkit-inline-box;
    max-width: 300px;
    color: ${colors.textBlack};
  `,
];

export const arrowCss = css`
  display: inline-block;
  width: 7px;
  height: 7px;
  border-top: 2px solid ${colors.grey};
  border-right: 2px solid ${colors.grey};
  transform: rotate(45deg);
  margin: 0 10px;
  border-radius: 1px;
`;
